@if (searchResult) {
    <div [class.search-result-active]="searchResult.active" [ngStyle]="{
        'top.%': searchResult.position.y,
        'left.%': searchResult.position.x,
        'height.%': searchResult.position.h || 2,
        'width.%': searchResult.position.w || 5,
        'display': isVisible() ? 'block' : 'none'
     }"
         class="search-result-rect"></div>
}